import React from 'react';
// @ts-ignore
import { NotificationBadge, Box } from 'components';
import { Link } from 'core/routing';
import { DateWithTooltip } from 'apps/components';

import {
  ContentWrapperStyled,
  TitleWrapperStyled,
  DateWrapperStyled,
  InboxItemStyled,
  UserNameStyled,
  FileNameStyled,
  ContentStyled,
  BorderStyled,
  TypeStyled,
  DateStyled,
} from './inboxItem.styled';

interface InboxItemProps {
  avatar?: React.ReactNode;
  onClick?: () => void;
  unreadCount?: number;
  fileName?: string;
  userName?: string;
  type?: string;
  body?: string;
  read?: boolean;
  date?: Date;
  titleTooltip?: string;
  dataFor?: string;
  routeName?: string;
  routeParams?: object;
}

const InboxItem = ({
  unreadCount,
  fileName,
  userName,
  onClick,
  avatar,
  read,
  body,
  type,
  date,
  titleTooltip,
  dataFor,
  routeName,
  routeParams,
}: InboxItemProps) => {
  return (
    <Link
      name={routeName}
      params={routeParams}
      openTab={{
        title: fileName,
        iconType: type?.replace(':', '').toLocaleLowerCase() || '',
      }}
    >
      <InboxItemStyled onClick={onClick}>
        <Box>{avatar}</Box>
        <ContentWrapperStyled>
          <TitleWrapperStyled data-tip={titleTooltip} data-for={dataFor}>
            <TypeStyled>{type}</TypeStyled>
            <FileNameStyled>{fileName}</FileNameStyled>
            <>&#8212;</>
            <UserNameStyled>{userName}</UserNameStyled>
          </TitleWrapperStyled>
          <ContentStyled>{body}</ContentStyled>
        </ContentWrapperStyled>
        <DateWrapperStyled>
          <DateStyled disabled={read}>
            <DateWithTooltip
              date={date}
              className=" w-fit"
              customFormat={() =>
                date.toLocaleString(undefined, {
                  day: 'numeric',
                  month: 'short',
                })
              }
            />
          </DateStyled>
          {unreadCount && !read ? (
            <NotificationBadge
              selfContained={true}
              value={unreadCount}
              color='success'
            />
          ) : null}
        </DateWrapperStyled>
        <BorderStyled />
      </InboxItemStyled>
    </Link>
  );
};

export default InboxItem;
